
import DirectRight from "../../../assets/duotone/DirectRight.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DirectRightIcon({ className, dataTestid = "DirectRightIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DirectRight data-testid={dataTestid} className={classes} {...rest} />
  );
}
